export default __webpack_public_path__ + "static/media/madhuri.b553ff3e.webp";